import React from 'react';
import { Link } from 'react-router-dom';

const Software = () => {
    const services = [
        {
            icon: '🎯',
            title: 'Custom Software Development',
            description: 'Bespoke software solutions designed and built specifically for your unique business requirements.'
        },
        {
            icon: '🏢',
            title: 'Enterprise Solutions',
            description: 'Scalable enterprise applications that streamline operations and drive efficiency.'
        },
        {
            icon: '🔌',
            title: 'API Development & Integration',
            description: 'Connect your systems and third-party services with robust API solutions.'
        },
        {
            icon: '🗄️',
            title: 'Database Design',
            description: 'Efficient database architecture for optimal data management and performance.'
        },
        {
            icon: '🔄',
            title: 'Legacy System Modernization',
            description: 'Upgrade outdated systems to modern, maintainable architectures.'
        },
        {
            icon: '📊',
            title: 'Business Intelligence',
            description: 'Data analytics and reporting solutions to drive informed decision-making.'
        }
    ];

    const industries = [
        'Healthcare', 'Finance', 'E-Commerce', 'Education',
        'Manufacturing', 'Logistics', 'Real Estate', 'Startups'
    ];

    return (
        <div className="page">
            {/* Hero Section */}
            <section className="page-hero" style={{ background: `linear-gradient(rgba(8,15,30,0.75) 0%, rgba(8,15,30,0.55) 100%), url(${process.env.PUBLIC_URL}/images/dual-monitors-dev.jpg) center/cover no-repeat`, color: 'white' }}>
                <div className="page-hero-content container">
                    <h1>Software <span className="text-gradient">Solutions</span></h1>
                    <p>
                        Custom software development tailored to your unique business needs,
                        workflows, and growth objectives.
                    </p>
                </div>
            </section>

            {/* Services Section */}
            <section className="section">
                <div className="container">
                    <div className="section-header">
                        <h2>Our <span className="text-gradient">Solutions</span></h2>
                        <p>End-to-end software development services for modern businesses</p>
                    </div>
                    <div className="services-grid">
                        {services.map((service, index) => (
                            <div key={index} className="card card-gradient service-card">
                                <div className="service-icon">{service.icon}</div>
                                <h3>{service.title}</h3>
                                <p>{service.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Industries Section */}
            <section className="section bg-dark">
                <div className="container">
                    <div className="section-header">
                        <h2>Industries We <span className="text-gradient">Serve</span></h2>
                        <p>Expertise across diverse sectors and business domains</p>
                    </div>
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '1rem',
                        justifyContent: 'center'
                    }}>
                        {industries.map((industry, index) => (
                            <span
                                key={index}
                                style={{
                                    padding: '1rem 2rem',
                                    background: 'rgba(6, 182, 212, 0.1)',
                                    border: '1px solid rgba(6, 182, 212, 0.3)',
                                    borderRadius: '0.75rem',
                                    fontSize: '1rem',
                                    fontWeight: '500'
                                }}
                            >
                                {industry}
                            </span>
                        ))}
                    </div>
                </div>
            </section>

            {/* Atmospheric divider */}
            <div
                className="image-divider"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/fiber-optic.jpg)` }}
            >
                <div className="divider-content">
                    <h2>Engineered for <span className="text-gradient">Reliability</span></h2>
                    <p>Every system we build is designed with fault tolerance, security, and longevity in mind.</p>
                </div>
            </div>

            {/* Why Custom Software Section */}
            <section className="section">
                <div className="container">
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
                        gap: '2rem',
                        alignItems: 'center'
                    }}>
                        <div>
                            <h2 className="mb-lg">Why Choose <span className="text-gradient">Custom Software</span>?</h2>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                                <div className="feature-item">
                                    <div className="feature-icon">✅</div>
                                    <div className="feature-content">
                                        <h4>Perfect Fit</h4>
                                        <p>Software built exactly to your specifications and workflows</p>
                                    </div>
                                </div>
                                <div className="feature-item">
                                    <div className="feature-icon">📈</div>
                                    <div className="feature-content">
                                        <h4>Scalability</h4>
                                        <p>Grow without limitations of off-the-shelf solutions</p>
                                    </div>
                                </div>
                                <div className="feature-item">
                                    <div className="feature-icon">🔒</div>
                                    <div className="feature-content">
                                        <h4>Full Ownership</h4>
                                        <p>Own your software and data without vendor lock-in</p>
                                    </div>
                                </div>
                                <div className="feature-item">
                                    <div className="feature-icon">⚡</div>
                                    <div className="feature-content">
                                        <h4>Competitive Edge</h4>
                                        <p>Unique solutions your competitors can't replicate</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card card-gradient" style={{ padding: '2.5rem', textAlign: 'center' }}>
                            <p style={{ fontSize: '4rem', marginBottom: '1rem' }}>💻</p>
                            <h3 className="mb-md">Ready to Build?</h3>
                            <p className="text-muted mb-lg">
                                Let's discuss your software requirements and create a solution
                                that drives your business forward.
                            </p>
                            <Link to="/contact" className="btn btn-primary">
                                Get Started →
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="section">
                <div className="container">
                    <div className="cta-section">
                        <div className="cta-content">
                            <h2>Have a Software Idea?</h2>
                            <p>
                                Share your vision with us and let's bring it to life together.
                            </p>
                            <Link to="/contact" className="btn btn-primary">
                                Discuss Your Project →
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Software;
